<template>
    <div class="container-fluid mx-3 md:mx-10 my-8">
        <transition-page>
            <router-view></router-view>
        </transition-page>
    </div>
</template>

<script>
    import TransitionPage from "../components/TransitionPage";

    export default {
        name: "Users",
        
        components: {
            TransitionPage
        }
    }
</script>

<style scoped>

</style>